import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'AgentStatusReason',
  properties: { agentName: prop(String) },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/modal/agent_status_reason.js